import type { SelectOption } from '@atlassian/jira-issue-field-select/src/ui/edit/types.tsx';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraMultiSelectFieldInput } from './types.tsx';

export const mutateMultiSelectField = (
	selectedValues: SelectOption[],
	fieldId: string,
): JiraMultiSelectFieldInput => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	options: selectedValues.map(({ value }) => ({ optionId: value })),
});

export const mapMultiSelectOptionsToConnectData = (options: SelectOption[]): string[] =>
	options.map((option: SelectOption): string => option.value);
